exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-fcf1ae48] {\n  text-align: center;\n  font-size: 40px;\n  padding-top: 100px;\n}\n", ""]);

// exports
